import { Button, Table } from "@mantine/core";
import { ButtonRowProps, TrProps } from "../../../types/types";
import { IconDownload, IconInfoCircle } from "@tabler/icons-react";
import { useState } from "react";
import { useDisclosure } from "@mantine/hooks";
import { MandateDetailsModal } from "../MandateDetailsModal/MandateDetailsModal";


export default function ButtonColumn<T extends Record<string, any>>(
    props: ButtonRowProps<T>
) {
    const [hovered, setHovered] = useState(false);
    const [openedMandateDetails, { open: openMandateDetails, close: closeMandateDetails }] =
        useDisclosure(false);

    async function handleDownload(ID: string, filename: string) {
        // Download the invoice pdf.
        const response = await fetch(window.location.origin + "/server/client_service/invoices/" + ID);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename + ".pdf";
        link.click();
    }

    function handleMandateDetails() {
        openMandateDetails();
    }



    function createButton(type: string, row: T) {
        console.log("Handling button for type: ", type, " and row: ", row);
        switch (type) {
            case "invs":
                return (
                    <Button
                        onClick={() => handleDownload(row["Invoice_ID"], row["Number"])}
                        variant="transparent"
                        style={{ color: "#00ddb3" }}
                    >
                        <IconDownload
                            size={25}
                            color={hovered ? "rgba(0, 132, 255, 1)" : "gray"}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)} />
                    </Button>
                );
            case "mandts":
                return (
                    <><Button
                        onClick={() => handleMandateDetails()}
                        variant="transparent"
                        style={{ color: "#00ddb3" }}
                    >
                        <IconInfoCircle size={25}
                            color={hovered ? "rgba(0, 132, 255, 1)" : "gray"}
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                        />
                    </Button>
                    <MandateDetailsModal
                            opened={openedMandateDetails}
                            close={closeMandateDetails}
                            mandateID={row["mandate_id"]} /></>
                );
            default:
                return <></>;
        }
    }

    return createButton(props.type, props.row);

}